<template>
    <div class="dialog-wrap">
        <el-dialog
            :title="title"
            :visible.sync="centerDialogVisible"
            :show-close="showClose"
            :width="dialogWidth"
            :close-on-click-modal="closeModal"
            center
            @close="onDialogClose"
        >
            <slot></slot>
            <span v-if="showBtns" slot="footer" class="dialog-footer">
                <el-button type="primary" @click="dialogConfirmClick">确 定</el-button>
                <el-button type="primary" plain @click="dialogVisibleCancelClick">取 消</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
export default {
    name: 'Commonpagination',
    props: {
        title: {
            required: true
        },
        dialogVisible: {
            required: true,
            default: false
        },
        showClose: {
            default: false
        },
        showBtns: {
            default: true
        },

        dialogWidth: {
            default: "30%"
        }
    },
    data() {
        return {
            closeModal: false,
            centerDialogVisible: this.dialogVisible
        };
    },
    computed: {},
    watch: {
        dialogVisible(val) {
            this.centerDialogVisible = val;
        }
    },
    mounted() {

    },
    methods: {
        dialogConfirmClick() {
            this.$emit('confirm')
        },
        dialogVisibleCancelClick() {
            this.$emit('cancel')
        },
        onDialogClose() {
            this.$emit('dialog-close')
        }
    }
}
</script>

<style lange="less" scoped>
    >>> .el-input{
        width: 96%;
    }
</style>
